import { RootState } from '../../store';

export const getIsLoadingSelector = (state: RootState) => state?.streetReducer?.isLoading;
